import { Divider } from "@mantine/core";
import CustomNotificationBanner from "../ui/CustomNotificationBanner/CustomNotificationBanner";

export function PaymentSummaryCard({
  title = "Payment Summary",
  summaryItems = [],
  bannerMessage,
  variant = "",
  descriptionColor,
}) {
  return (
    <div className="w-full md:w-72 lg:w-80 shrink-0 md:self-start bg-white rounded-xl border border-gray-200 shadow-sm p-6 sm:p-8">
      <h2 className="text-sm sm:text-base font-semibold text-gray-900 mb-3">
        {title}
      </h2>

      <div>
        {summaryItems.map(({ label, value, status }, index) => (
          <div
            key={`${index}-${label}`}
            className="flex items-center justify-between gap-4 text-sm py-2.5 border-b border-gray-100 last:border-b-0"
          >
            <span className="text-gray-500 shrink-0">{label}</span>
            <div className="flex items-center gap-1.5 min-w-0">
              {status && (
                <span
                  className={`w-2 h-2 rounded-full shrink-0 ${
                    status === "success" ? "bg-green-500" : "bg-red-500"
                  }`}
                />
              )}
              <span className="font-medium text-gray-900 text-right truncate">
                {value}
              </span>
            </div>
          </div>
        ))}
      </div>

      {bannerMessage && (
        <>
          <Divider className="my-4" />
          <CustomNotificationBanner
            variant={variant}
            descriptionColor={descriptionColor}
            message={bannerMessage}
            withCloseButton={false}
          />
        </>
      )}
    </div>
  );
}
